import React, { useRef } from 'react';
import { MenuCard } from './MenuCard';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { KebabIcon } from './SectionIcons';
export function Kebabs() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20" data-id="element-59" data-mp="1ura00u8mjaju">
      <div className="max-w-container mx-auto" data-id="element-60" data-mp="28rufphj8sq94">
        <motion.div ref={ref} className="flex flex-col items-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-61" data-mp="28qjcbitplkij">
          <KebabIcon className="mb-4" data-id="element-62" data-mp="2ni1nn3bmiqvk" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase text-center" data-id="element-63" data-mp="2new19vudq33j">
            KEBABS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-12 max-w-4xl mx-auto" data-id="element-64" data-mp="1euu55cfh96sd">
          <MenuCard name="POLLO" price="19.000" ingredients={['Pan artesanal.', 'Pollo marinado.', 'Cebolla encurtida.', 'Mix de vegetales frescos.', 'Salsa de ajo.']} delay={0} data-id="element-65" data-mp="1ium4qzmw82ll" />

          <MenuCard name="RES" price="19.000" ingredients={['Pan artesanal.', 'Res marinada.', 'Cebolla encurtida.', 'Mix de vegetales frescos.', 'Salsa de ajo.']} delay={0.1} data-id="element-66" data-mp="1xrbuxoarmwlz" />
        </div>

        {/* Salsa Brava Block */}
        <motion.div className="bg-bp-bg3 border border-bp-line2 rounded-bp p-8 max-w-2xl mx-auto text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-67" data-mp="2gkpd0stdr8k6">
          <h3 className="font-display text-3xl text-bp-accent tracking-wider uppercase mb-6" data-id="element-68" data-mp="za8v8xdown7w">
            SALSA BRAVA
          </h3>

          <div className="flex flex-wrap justify-center gap-10" data-id="element-69" data-mp="196vgvodubiaz">
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-70" data-mp="193zki4hn51on">
              <span data-id="element-71" data-mp="145fwlyjhlftn">○</span> Sin picante
            </p>
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-72" data-mp="3ayrrmvs6oo4p">
              <span data-id="element-73" data-mp="35znj87d32uff">◐</span> Medio
            </p>
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-74" data-mp="360yoycq3ac96">
              <span data-id="element-75" data-mp="1lixm1fzu7ezz">●</span> Alto
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}